import React, { useEffect } from 'react';
import AddressContainer from 'app/containers/common/AddressContainer';
import Layout from 'app/components/common/Layout';
import PagePortal from 'app/components/common/PagePortal';

function PageAddress({ onClose, onSubmit }) {
	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, []);

	return (
		<PagePortal>
			<Layout
				usePageHook
				title="주소검색"
				useCloseBtn="left"
				onClose={onClose}
				usePc
				enlogConfig={{
					dataTalkViewAuto: false,
				}}
			>
				<AddressContainer onSubmit={onSubmit} />
			</Layout>
		</PagePortal>
	);
}

export default PageAddress;
